import { BiMultiMapContext, } from '@rimbu/bimultimap/custom';
import { SortedMultiMapSortedValue } from '@rimbu/multimap';
function createContext(options) {
    return Object.freeze(new BiMultiMapContext('SortedBiMultiMap', options?.keyValueMultiMapContext ??
        SortedMultiMapSortedValue.defaultContext(), options?.valueKeyMultiMapContext ??
        SortedMultiMapSortedValue.defaultContext()));
}
const _defaultContext = createContext();
export const SortedBiMultiMap = Object.freeze({
    ..._defaultContext,
    createContext,
    defaultContext() {
        return _defaultContext;
    },
});
//# sourceMappingURL=index.mjs.map